<template>
    <div class="pt-8">
        <b-row> 
            <b-col cols="12" md="6" v-if="canSeeTopSellingItems" class="mb-3 mb-md-0">
                <top-selling-items />
            </b-col>

            <b-col cols="12" md="6" v-if="canSeeTopSeller" class="mb-3 mb-md-0">
                <top-seller />
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12" md="6" v-if="canSeeTopSupplierSellingItems" class="mb-3 mb-md-0">
                <top-supplier-selling-items />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import TopSellingItems from '../components/TopSellingItems.vue'
import TopSeller from '../components/TopSeller.vue'
import TopSupplierSellingItems from '../components/TopSupplierSellingItems.vue';

import { mapState } from 'vuex'

export default {
    components: {
        TopSellingItems,
        TopSeller,
        TopSupplierSellingItems
        
    },
    computed: {
        ...mapState('auth', ['user']),
        canSeeTopSellingItems() {
            //return this.user.permissions.includes('can_see_top_selling_items');
            return this.user.isMaster === 1;
        },
        canSeeTopSeller() {
            //return this.user.permissions.includes('can_see_top_seller');
            return this.user.isMaster === 1;
        },
        canSeeTopSupplierSellingItems() {
            //return this.user.permissions.includes('can_see_top_seller');
            return this.user.isMaster === 1;
        }
    },
    data() {
        return {
        };
    },
    methods: {
       
    }
}
</script>
